import { render, staticRenderFns } from "./NoticeManagementModify.vue?vue&type=template&id=b2d490e4&scoped=true"
import script from "./NoticeManagementModify.vue?vue&type=script&lang=js"
export * from "./NoticeManagementModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d490e4",
  null
  
)

export default component.exports